import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import ResourceList from "./resource-list.vue";
import AddResourceToUsed from "./add-resource-to-used.vue";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    components: {
        ResourceList: ResourceList,
        AddResourceToUsed: AddResourceToUsed
    },
    inject: [
        "show",
        "hide"
    ],
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        var getTargetTypeComponents = function(tags) {
            emit("viewTagAllData", tags);
        };
        return {
            handleAddResource: handleAddResource,
            getTargetTypeComponents: getTargetTypeComponents
        };
    }
});
